export default __webpack_public_path__ + "static/media/no-image.4283d755.jpg";